import { Mutex } from 'async-mutex';
export class TaggedMutex {
    cancelError;
    mutexes = new Map();
    constructor(cancelError) {
        this.cancelError = cancelError;
    }
    async acquire(tag, priority) {
        const mutex = this.refMutex(tag);
        try {
            await mutex.acquire(priority);
        }
        catch (error) {
            this.unrefMutex(tag);
            throw error;
        }
        return this.release.bind(this, tag);
    }
    release(tag) {
        const mutex = this.mutexes.get(tag);
        if (!mutex) {
            return;
        }
        mutex.release();
        this.unrefMutex(tag);
    }
    async runExclusive(tag, callback, priority) {
        const mutex = this.refMutex(tag);
        try {
            return await mutex.runExclusive(callback, priority);
        }
        finally {
            this.unrefMutex(tag);
        }
    }
    cancel(tag) {
        const mutex = this.mutexes.get(tag);
        mutex?.cancel();
    }
    isLocked(tag) {
        const mutex = this.mutexes.get(tag);
        return mutex?.isLocked() ?? false;
    }
    waitForUnlock(tag, priority) {
        const mutex = this.mutexes.get(tag);
        return mutex?.waitForUnlock(priority) ?? Promise.resolve();
    }
    setCancelError(cancelError) {
        this.cancelError = cancelError;
    }
    refMutex(tag) {
        let mutex = this.mutexes.get(tag);
        if (!mutex) {
            mutex = Object.assign(new Mutex(this.cancelError), { refCount: 1 });
            this.mutexes.set(tag, mutex);
        }
        else {
            ++mutex.refCount;
        }
        return mutex;
    }
    unrefMutex(tag) {
        const mutex = this.mutexes.get(tag);
        if (!mutex) {
            return;
        }
        --mutex.refCount;
        if (mutex.refCount <= 0) {
            this.mutexes.delete(tag);
        }
    }
}
